import * as types from '../constants/SportradarActionTypes'
import {env} from '../constants/Environment';

const USE_SNAPSHOTS = false;

export function load_match (firestore, id){
	return function(dispatch){	
        return (new Promise((resolve, reject) => {				
				(async () => {
					let snapshot = await firestore.doc('environments/' + env + '/stats/sportradar/matches/' + id).get();
                    if(snapshot.exists){
                        dispatch({
                            type: types.RECEIVED_MATCH,
                            id: id,
                            data: snapshot.data()
                        })
                    }else{
                        dispatch({
                            type: types.RECEIVED_MATCH,
                            id: id,
                            data: null
                        })
                    }

                    resolve();
                })();
			}));
	}  
}

export function load_leaguetables (firestore, sportId, categoryId, tournamentId, seasonId) {
	return function(dispatch){	
        return (new Promise((resolve, reject) => {				
				(async () => {
					let snapshot = await firestore.collection('environments/' + env + '/stats/sportradar/sports/' + sportId + '/categories/' + categoryId + '/tournaments/' + tournamentId + '/seasons/' + seasonId + '/leaguetable').get();
                    let leaguetables = [];
                    
                    snapshot.forEach((doc) => {
                        leaguetables.push(doc.data());
                    });

                    dispatch({
                        type: types.RECEIVED_LEAGUETABLES,
                        sport: sportId,
                        category: categoryId,
                        tournament: tournamentId,
                        season: seasonId,
                        leaguetables: leaguetables
                    });

                    resolve();
                })();
			}));
	}
}

export function load_prematch (firestore, id) {
	return function(dispatch){	
        return (new Promise((resolve, reject) => {				
				(async () => {
					let snapshot = await firestore.collection('environments/' + env + '/stats/sportradar/matches/' + id + '/prematch').get();
                    let prematch = {};
                    
                    snapshot.forEach((doc) => {
                        prematch[doc.id] = doc.data();
                    });

                    dispatch({
                        type: types.RECEIVED_PREMATCH,
                        id: id,
                        data: prematch
                    });

                    resolve();
                })();
			}));
	}
}

export function load_live (firestore, id) {
	return function(dispatch){	
        /*return (new Promise((resolve, reject) => {				
				(async () => {
					const observer = firestore.collection('environments/' + env + '/programs/0/sport').onSnapshot((querySnapshot) => {
                        let sports = [];

                        querySnapshot.forEach(function(doc) {
                            sports.push(doc.data());
                        });

                        dispatch({
                            type: types.RECEIVE_SPORTS,
                            sports: sports
                        })

                        if(!USE_SNAPSHOTS)
                            observer();
                    });

                    resolve();
                })();
			}));*/
	}
}
